import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=488d80b8&"
import script from "./Ingredient.vue?vue&type=script&lang=js&"
export * from "./Ingredient.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports